"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _Icon = require("../../../Icon");
var _Menu = require("../../../Menu");
var _ScrollSelector = require("../../../ScrollSelector");
var _DateTimePickers = require("../../DateTimePickers.labels");
var _hooks = require("../../../../hooks");
var _strings = require("../../../../utilities/strings");
var _TimePicker = _interopRequireDefault(require("../TimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MobileView = function MobileView(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var defaultHourOption = props.defaultHourOption,
    defaultMinuteOption = props.defaultMinuteOption,
    hourOptions = props.hourOptions,
    minutesOptions = props.minutesOptions,
    onTimeChange = props.onTimeChange;
  var styles = (0, _TimePicker.default)(true, 'roundedRectangle');
  var getLabel = (0, _hooks.useLabels)({
    labels: _DateTimePickers.labels
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBoxAnimationComplete = _useState2[0],
    setIsBoxAnimationComplete = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultHourOption.value),
    _useState4 = _slicedToArray(_useState3, 2),
    scrolledHour = _useState4[0],
    setScrolledHour = _useState4[1];
  var _useState5 = (0, _react.useState)(defaultMinuteOption.value),
    _useState6 = _slicedToArray(_useState5, 2),
    scrolledMinute = _useState6[0],
    setScrolledMinute = _useState6[1];
  var btnProps = {
    view: 'text',
    color: 'basic',
    width: 65,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-TimePicker__anchor-btn'],
      children: [(0, _strings.padNumberWithPrefixZero)(defaultHourOption.value), ":", (0, _strings.padNumberWithPrefixZero)(defaultMinuteOption.value), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "Caret",
        width: 12,
        height: 12,
        fillColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main
      })]
    })
  };
  var handleConfirm = function handleConfirm() {
    onTimeChange(scrolledHour, scrolledMinute);
  };
  var handleBoxAnimationComplete = function handleBoxAnimationComplete() {
    setIsBoxAnimationComplete(true);
    setTimeout(function () {
      setIsBoxAnimationComplete(false);
    }, 1000);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-TimePicker'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
      btnProps: btnProps,
      defaultTitle: getLabel('choose_time'),
      isWithActionButtons: true,
      onConfirm: handleConfirm,
      onBoxAnimationComplete: handleBoxAnimationComplete,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-TimePicker__scroll-selector-container'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScrollSelector.ScrollSelector, {
          scrollOptions: minutesOptions,
          defaultOption: isBoxAnimationComplete ? defaultMinuteOption : undefined,
          onScrollValueChange: function onScrollValueChange(value) {
            setScrolledMinute(value);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScrollSelector.ScrollSelector, {
          scrollOptions: hourOptions,
          defaultOption: isBoxAnimationComplete ? defaultHourOption : undefined,
          onScrollValueChange: function onScrollValueChange(value) {
            setScrolledHour(value);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-TimePicker__scroll-selector-mask']
        })]
      })
    })
  });
};
exports.MobileView = MobileView;